import React from "react";
import { useClasses } from "../../../";
import classNames from "classnames";
import Label from "./Label";
const style = (theme) => {
    return {
        formControl: {
            position: "relative",
        },
        inputHolder: {
            padding: "18px 0px 0px 0px",
        },
        input: {
            display: "block",
            width: "100%",
            height: "32px",
            boxSizing: "border-box",
            backgroundColor: theme.palette.get("formBackground"),
            outline: "none",
            border: "none",
            borderRadius: "2px",
            padding: "5px 8px  5px 8px",
            fontSize: "1rem",
            textOverflow: "ellipsis",
            "&:focus": {
                backgroundColor: theme.palette.get("formBackgroundActive"),
                transition: "background-color 150ms linear",
            },
        },
        inputReadOnly: {
            backgroundColor: "rgba(0, 0, 0, 0)",
            padding: "5px 8px  5px 2px",
            "&:focus": {
                backgroundColor: "rgba(0, 0, 0, 0)",
            },
        },
        textarea: {
            display: "block",
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: theme.palette.get("formBackground"),
            outline: "none",
            border: "none",
            borderRadius: "2px",
            padding: "5px 8px  5px 8px",
            fontSize: "1rem",
            textOverflow: "ellipsis",
            resize: "none",
            "&:focus": {
                backgroundColor: theme.palette.get("formBackgroundActive"),
                transition: "background-color 150ms linear",
            },
        },
        helpBlock: {
            fontSize: "0.8rem",
            lineHeight: "0.8rem",
            color: "rgba(0, 0, 0, 0.75)",
        },
        hasError: {
            color: "rgba(156, 0, 0, 1)",
        },
        suggestion: {},
    };
};
export default function Field(props) {
    const { label, readOnly = false, open = false, inline = false, hasValue, error, info, isFocused, } = props;
    const classes = useClasses(style);
    const hasInfo = Boolean(info);
    const hasError = Boolean(error);
    return (React.createElement("div", { className: classes.formControl, onClick: () => {
            if (props.onClick)
                props.onClick();
        } },
        !props.hideLabel && (React.createElement(Label, { open: open, inline: inline, label: label || "", readOnly: readOnly, isFocused: isFocused, hasValue: hasValue, hasError: hasError, onClick: props.onLabelClick })),
        props.children,
        hasInfo && !hasError && (React.createElement("span", { className: classNames([classes.helpBlock]) }, info)),
        hasError && (React.createElement("span", { className: classNames([classes.helpBlock, classes.hasError]) }, error))));
}
